<template>
  <MyModal
    title="资源概况"
    height="auto"
    v-if="isShowPoint"
    :className="classNames"
    width="420px"
    @closeClick="handleCloseModalClick('point')"
  >
    <div class="mycontent">
      <div class="top-area">
        <div class="item">
          <div class="label">经纬度:</div>
          <div class="desc">
            <el-tag> E{{ toFixed(config.lon, 6) }} </el-tag>
            <el-divider direction="vertical"></el-divider>
            <el-tag> N{{ toFixed(config.lat, 6) }} </el-tag>
          </div>
        </div>
        <div class="item">
          <div class="label">数据源:</div>
          <div class="desc">
            <el-select
              v-model="datasetCode"
              placeholder="选择数据源"
              @change="handleSelectChange"
            >
              <el-option
                v-for="(v, i) in dataSet"
                :key="i"
                :label="v.datasetName"
                :value="v.datasetCode"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div class="item">
          <div class="label">高度:</div>
          <div class="desc">
            <el-select v-model="datasetHeight" placeholder="选择高度">
              <el-option
                v-for="(v, i) in heightList"
                :key="i"
                :label="v + 'm'"
                :value="v"
              ></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="middle-area">
        <div class="row">
          <div class="row-item">
            <div class="key"><span>平均风速</span> :</div>
            <div class="value">
              <el-tag v-if="summaryData.bias"> {{ summaryData.windSpeed || '-' }} ±{{ Math.abs(summaryData.bias)}} m/s</el-tag>
              <el-tag v-else> {{ summaryData.windSpeed || '-' }} m/s</el-tag>
            </div>
          </div>
          <div class="row-item">
            <div class="key"><span>海拔</span> :</div>
            <div class="value">
              <el-tag>{{ summaryData.altitude || '-' }} m</el-tag>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row-item">
            <div class="key"><span>空气密度</span> :</div>
            <div class="value">
              <el-tag> {{ summaryData.airDensity || '-' }} kg/m³ </el-tag>
            </div>
          </div>
          <div class="row-item">
            <div class="key"><span>风功率密度</span> :</div>
            <div class="value">
              <el-tag>{{ summaryData.powerDensity || '-' }} W/㎡</el-tag>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row-item">
            <div class="key"><span>平均温度</span> :</div>
            <div class="value">
              <el-tag>{{ summaryData.airTemperature || '-' }} ℃</el-tag>
            </div>
          </div>
          <div class="row-item">
            <div class="key"><span>气压</span> :</div>
            <div class="value">
              <el-tag>{{ summaryData.pressure || '-' }} hPa</el-tag>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row-item">
            <div class="key"><span>威布尔 A</span> :</div>
            <div class="value">
              <el-tag>{{ summaryData.a || '-' }}</el-tag>
            </div>
          </div>
          <div class="row-item">
            <div class="key"><span>威布尔 K</span> :</div>
            <div class="value">
              <el-tag>{{ summaryData.k || '-' }}</el-tag>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="row-item">
            <div class="key"><span>风切变指数</span> :</div>
            <div class="value">
              <el-tag>{{ summaryData.alpha || '-' }}</el-tag>
            </div>
          </div>
          <div class="row-item">
            <div class="key"><span>发电小时</span> :</div>
            <div class="value">
              <el-tag>{{ summaryData.fullLoadHour || '-' }} h </el-tag>
              <el-tooltip class="item" effect="dark" :content="'参考机型 :' + (summaryData.turbineType || '-')" placement="top">
                <i class="el-icon-info" style="font-size:16px; color:#3271A1;margin-left:4px;"></i>
              </el-tooltip>

            </div>
          </div>
        </div>
      </div>
      <div class="btn-area" v-if="buttonFlag">
        <div
          v-for="(item, index) in btnList"
          :key="index"
          :class="[
            'btn-item',
            {
              'is-disabled': !(buttonFlag.split(',').length > index && buttonFlag.split(',')[index]=='1')
            },
            {
              'is-active': chartType && item.name === chartType.name
            }
          ]"
          @click="buttonFlag.split(',').length > index && buttonFlag.split(',')[index]=='1'?handleBtnClick(item, index):null"
        >
          {{ item.name }}
        </div>
      </div>
      <div style="text-align: right;padding:5px 30px">
        <el-button v-if="isLogin && reportFlag == '1'" type="text" @click="handleDownReport">资源报告</el-button>
        <el-button v-if="itemConfig.itemId == 0" type="text" @click="add">保存</el-button>
      </div>
    </div>

    <modal
      title="数据下载"
      :visible.sync="showDataDownLoadDialog"
      @close="dialogClose"
      width="400px"
    >
      <div class="data-content">
        <el-form
          ref="form"
          :rules="uploadrules"
          :model="uploadForm"
          label-width="120px"
        >
          <el-form-item label="数据源" prop="datasetCode">
            <el-select
              v-model="uploadForm.datasetCode"
              @change="handleDataDownChange"
            >
              <el-option
                v-for="(item, index) in dataDownSet"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="开始时间" prop="startDate">
            <el-date-picker
              v-model="uploadForm.startDate"
              type="date"
              placeholder="选择开始日期"
              value-format="yyyy-MM-dd"
              :default-value="defaultStartDate"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="结束时间" prop="endDate">
            <el-date-picker
              v-model="uploadForm.endDate"
              type="date"
              placeholder="选择开始日期"
              value-format="yyyy-MM-dd"
              :default-value="defaultEndDate"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
        <div class="vtn-wrp">
          <ct-button type="primary" :btnClick="handleDatasetClick"
            >下载</ct-button
          >
        </div>
      </div>
    </modal>

    <MyModal
      v-if="chartType"
      className="chart-modal"
      :title="chartType.name"
      width="420px"
      height="350px"
      @closeClick="handleCloseModalClick('chart')"
    >
      <div class="plus-content">
        <div v-if="chartType.name === '威布尔分布'">
          <div class="AAndK">
            <span>A: {{ weibullA }}</span>,
            <span>K: {{ weibullK }}</span>
          </div>
        </div>
        <div v-if="chartType.name === '风切变'">
          <div class="exp">
            <div>幂指数: {{ exp }}</div>
          </div>
        </div>
      </div>
      <div class="chart-content">
        <div class="chart-c">
          <Chart v-if="!loading" :option="chartOption"></Chart>
        </div>
      </div>
    </MyModal>
  </MyModal>
</template>

<script>
import moment from 'moment';
import MyModal from '../../modal';
import { mapGetters } from 'vuex';
import { toFixed, requestChart, getQueryString } from '../../utils';
import Chart from '../chart';
import loadingMask from '@/components/loading-mask';
import { getToken } from '@/utils';
export default {
  components: {
    MyModal,
    Chart
  },
  props: {
    itemConfig: {
      type: Object,
      default: () => ({})
    },
    fromProjectList: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      exp: '',
      isShowPoint: true,
      uploadrules: {
        datasetCode: [
          { required: true, message: '请选择数据源', trigger: 'change' }
        ],
        startDate: [
          { required: true, message: '请选择开始时间', trigger: 'change' }
        ],
        endDate: [
          { required: true, message: '请选择结束时间', trigger: 'change' }
        ]
      },
      uploadForm: {
        datasetCode: '',
        startDate: '',
        endDate: ''
      },
      defaultStartDate: '',
      defaultEndDate: '',
      weibullA: '',
      weibullK: '',
      dataDownSet: [],
      showDataDownLoadDialog: false,
      chartOption: {},
      datasetCode: 'c9km_wind',
      reportFlag: 0,
      buttonFlag: '',
      datasetHeight: '',
      chartType: null,
      config: {
        itemName: '',
        lat: '',
        lon: '',
        datasetCode: '',
        datasetHeight: ''
      },
      summaryData: {
        altitude: '-',
        turbineType: '-',
        airTemperature: '-',
        powerDensity: '-',
        fullLoadHour: '-',
        loce: '-',
        pressure: '-',
        windSpeed: '-',
        airDensity: '-'
      },

      loading: false,

      heightList: [],
      btnList: [
        {
          name: '风速月变化',
          chartOptions: data => {
            const { powerDensity, windSpeed } = data;
            const mounths = new Array(12).fill('').map((i, index) => index + 1);

            return {
              animation: false,
              grid: {
                right: '50',
                top: '40'
              },
              legend: {
                data: ['风功率密度', '风速'],
                bottom: 10
              },
              toolbox: {
                bottom: 0,
                emphasis: {
                  iconStyle: {
                    textPosition: 'left'
                  }
                },
                feature: {
                  dataView: { readOnly:  true}
                }
              },
              tooltip: {
                trigger: 'axis',
                formatter: params => {
                  const str = params
                    .map((serie, index) => {
                      return (
                        serie.marker +
                        serie.seriesName +
                        '：' +
                        serie.data +
                        (index === 0 ? 'm/s' : 'W/㎡')
                      );
                    })
                    .join('<br/>');

                  return str;
                }
              },
              xAxis: {
                nameLocation: 'end',
                boundaryGap: false,
                // nameTextStyle: {
                //   padding: [26, 0, 0, -10]  // 四个数字分别为上右下左与原位置距离
                // },
                // axisLabel: {
                //   padding:[0, 0, 0, 30]
                // },
                scale: true,
                type: 'category',
                // max: 12,
                // splitNumber: 12,
                name: '月份',
                data: mounths,
                axisTick: {
                  show: true
                },
                axisLine: {},
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              yAxis: [
                {
                  min: 0,
                  max: value => {
                    if (value.max <= 10) {
                      return 10;
                    }

                    let max = value.max * 1.2;
                    let val = max / 5;
                    const round = false;
                    const exponent = Math.floor(Math.log(val) / Math.LN10);
                    const exp10 = Math.pow(10, exponent);
                    const f = val / exp10; // 1 <= f < 10
                    let nf;
                    if (round) {
                      if (f < 1.5) {
                        nf = 1;
                      } else if (f < 2.5) {
                        nf = 2;
                      } else if (f < 4) {
                        nf = 3;
                      } else if (f < 7) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    } else {
                      if (f < 1) {
                        nf = 1;
                      } else if (f < 2) {
                        nf = 2;
                      } else if (f < 3) {
                        nf = 3;
                      } else if (f < 5) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    }
                    val = nf * exp10;
                    return val * 5;
                  },
                  splitNumber: 5,
                  axisLine: {
                    lineStyle: {}
                  },
                  splitLine: {
                    lineStyle: {
                      type: 'dashed'
                    }
                  },
                  name: '风速(m/s)',
                  type: 'value'
                },
                {
                  min: 0,
                  max: value => {
                    if (value.max <= 10) {
                      return 10;
                    }

                    let max = value.max * 1.2;
                    let val = max / 5;
                    const round = false;
                    const exponent = Math.floor(Math.log(val) / Math.LN10);
                    const exp10 = Math.pow(10, exponent);
                    const f = val / exp10; // 1 <= f < 10
                    let nf;
                    if (round) {
                      if (f < 1.5) {
                        nf = 1;
                      } else if (f < 2.5) {
                        nf = 2;
                      } else if (f < 4) {
                        nf = 3;
                      } else if (f < 7) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    } else {
                      if (f < 1) {
                        nf = 1;
                      } else if (f < 2) {
                        nf = 2;
                      } else if (f < 3) {
                        nf = 3;
                      } else if (f < 5) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    }
                    val = nf * exp10;
                    return val * 5;
                  },
                  splitNumber: 5,
                  axisLine: {
                    lineStyle: {}
                  },
                  splitLine: {
                    lineStyle: {
                      type: 'dashed'
                    }
                  },
                  axisLabel: {
                    showMinLabel: false
                  },
                  name: '风功率密度(W/㎡)',
                  type: 'value'
                }
              ],
              series: [
                {
                  name: '风速',
                  data: windSpeed.map(i => toFixed(i, 2)),
                  type: 'line',
                  symbol : 'none',
                  smooth: true
                },
                {
                  yAxisIndex: 1,
                  name: '风功率密度',
                  data: powerDensity.map(i => toFixed(i, 2)),
                  type: 'line',
                  symbol : 'none',
                  smooth: true
                }
              ]
            };
          },
          url: '/windfarm/meso/point/getWindAndPowerMonth',
          fileUrl: '/windfarm/meso/point/report/getWindMonth',
          key: 'windMonthChart'
        },
        {
          name: '风速日变化',
          chartOptions: data => {
            const { powerDensity, windSpeed } = data;

            const days = new Array(24).fill('').map((i, index) => index);

            return {
              animation: false,
              grid: {
                right: '50',
                top: '40'
              },
              legend: {
                data: ['风功率密度', '风速'],
                bottom: 10
              },
              toolbox: {
                bottom: 0,
                emphasis: {
                  iconStyle: {
                    textPosition: 'left'
                  }
                },
                feature: {
                  dataView: { readOnly:  true}
                }
              },
              tooltip: {
                trigger: 'axis',
                formatter: params => {
                  const str = params
                    .map((serie, index) => {
                      return (
                        serie.marker +
                        serie.seriesName +
                        '：' +
                        serie.data +
                        (index === 0 ? 'm/s' : 'W/㎡')
                      );
                    })
                    .join('<br/>');
                  return str;
                }
              },
              xAxis: {
                type: 'category',
                name: '小时',
                data: days,
                boundaryGap: false,
                axisTick: {
                  show: true
                },
                axisLabel: {
                  interval: 1
                },
                axisLine: {
                  lineStyle: {}
                },
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              yAxis: [
                {
                  min: 0,
                  max: value => {
                    if (value.max <= 10) {
                      return 10;
                    }

                    let max = value.max * 1.2;
                    let val = max / 5;
                    const round = false;
                    const exponent = Math.floor(Math.log(val) / Math.LN10);
                    const exp10 = Math.pow(10, exponent);
                    const f = val / exp10; // 1 <= f < 10
                    let nf;
                    if (round) {
                      if (f < 1.5) {
                        nf = 1;
                      } else if (f < 2.5) {
                        nf = 2;
                      } else if (f < 4) {
                        nf = 3;
                      } else if (f < 7) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    } else {
                      if (f < 1) {
                        nf = 1;
                      } else if (f < 2) {
                        nf = 2;
                      } else if (f < 3) {
                        nf = 3;
                      } else if (f < 5) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    }
                    val = nf * exp10;
                    return val * 5;
                  },
                  splitNumber: 5,
                  axisLine: {
                    lineStyle: {}
                  },
                  splitLine: {
                    lineStyle: {
                      type: 'dashed'
                    }
                  },
                  name: '风速(m/s)',
                  type: 'value'
                },
                {
                  min: 0,
                  max: value => {
                    if (value.max <= 10) {
                      return 10;
                    }

                    let max = value.max * 1.2;
                    let val = max / 5;
                    const round = false;
                    const exponent = Math.floor(Math.log(val) / Math.LN10);
                    const exp10 = Math.pow(10, exponent);
                    const f = val / exp10; // 1 <= f < 10
                    let nf;
                    if (round) {
                      if (f < 1.5) {
                        nf = 1;
                      } else if (f < 2.5) {
                        nf = 2;
                      } else if (f < 4) {
                        nf = 3;
                      } else if (f < 7) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    } else {
                      if (f < 1) {
                        nf = 1;
                      } else if (f < 2) {
                        nf = 2;
                      } else if (f < 3) {
                        nf = 3;
                      } else if (f < 5) {
                        nf = 5;
                      } else {
                        nf = 10;
                      }
                    }
                    val = nf * exp10;
                    return val * 5;
                  },
                  splitNumber: 5,
                  axisLine: {
                    lineStyle: {}
                  },
                  splitLine: {
                    lineStyle: {
                      type: 'dashed'
                    }
                  },
                  axisLabel: {
                    showMinLabel: false
                  },
                  name: '风功率密度(W/㎡)',
                  type: 'value'
                }
              ],
              series: [
                {
                  name: '风速',
                  data: windSpeed.map(i => toFixed(i, 2)),
                  type: 'line',
                  symbol : 'none',
                  smooth: true
                },
                {
                  yAxisIndex: 1,
                  name: '风功率密度',
                  data: powerDensity.map(i => toFixed(i, 2)),
                  type: 'line',
                  symbol : 'none',
                  smooth: true
                }
              ]
            };
          },
          url: '/windfarm/meso/point/getWindAndPowerDay',
          fileUrl: '/windfarm/meso/point/report/getWindDay',
          key: 'windDayChart'
        },
        {
          name: '威布尔分布',
          chartOptions: data => {
            const {
              speed,
              wsFrequency,
              wpdFrequency,
              weibullA = '',
              weibullK = '',
              weibullData = []
            } = data;
            this.weibullA = toFixed(weibullA, 3);
            this.weibullK = toFixed(weibullK, 3);
            return {
              animation: false,
              grid: {
                right: '20',
                top: '40'
              },
              legend: {
                data: ['风速频率', '风能频率'],
                bottom: 10
              },
              toolbox: {
                bottom: 0,
                emphasis: {
                  iconStyle: {
                    textPosition: 'left'
                  }
                },
                feature: {
                  dataView: { readOnly:  true}
                }
              },
              tooltip: {
                trigger: 'axis'
              },
              xAxis: {
                name: '风速(m/s)',
                data: speed,
                // boundaryGap: false,
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                },
                nameLocation: 'middle',
                nameGap: -15,
                nameTextStyle: {
                  padding: [0, 0, 0, 300]
                }
              },
              yAxis: {
                min: 0,
                max: value => {
                  if (value.max <= 10) {
                    return 10;
                  }
                  let max = value.max * 1;
                  let val = max / 5;
                  const round = false;
                  const exponent = Math.floor(Math.log(val) / Math.LN10);
                  const exp10 = Math.pow(10, exponent);
                  const f = val / exp10; // 1 <= f < 10
                  let nf;
                  if (round) {
                    if (f < 1.5) {
                      nf = 1;
                    } else if (f < 2.5) {
                      nf = 2;
                    } else if (f < 4) {
                      nf = 3;
                    } else if (f < 7) {
                      nf = 5;
                    } else {
                      nf = 10;
                    }
                  } else {
                    if (f < 1) {
                      nf = 1;
                    } else if (f < 2) {
                      nf = 2;
                    } else if (f < 3) {
                      nf = 3;
                    } else if (f < 5) {
                      nf = 5;
                    } else {
                      nf = 10;
                    }
                  }
                  val = nf * exp10;
                  return val * 5;
                },
                name: '频率(%)',
                type: 'value',
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              series: [
                {
                  name: '风速频率',
                  data: wsFrequency.map(i => toFixed(i, 2)),
                  type: 'bar'
                },
                {
                  name: '风能频率',
                  data: wpdFrequency.map(i => toFixed(i, 2)),
                  type: 'bar'
                },
                {
                  name: '威布尔曲线',
                  data: weibullData.map(i => toFixed(i, 2)),
                  type: 'line',
                  symbol : 'none',
                  smooth: true
                }
              ]
            };
          },
          url: '/windfarm/meso/point/getWeibull',
          fileUrl: '/windfarm/meso/point/report/getWeibull',
          key: 'weibullChar'
        },
        {
          name: '分扇区风速',
          chartOptions: data => {

            let sector = data.sector;
            let wsrose = data.wsrose.map(i => toFixed(i, 2));
            let arose = data.arose.map(i => toFixed(i, 2));
            let krose = data.krose.map(i => toFixed(i, 2));

            let wsroses = [],aroses = [], kroses = [];
            for (let i = 0; i < sector.length; i++) {
              wsroses.push([wsrose[i], i*22.5]);
              aroses.push([arose[i], i*22.5]);
              kroses.push([krose[i], i*22.5]);
            }
            wsroses.push(wsroses[0]);
            aroses.push(aroses[0]);
            kroses.push(kroses[0]);

            return {
              animation: false,
              textStyle: {},
              legend: {
                data: ['风速', 'A', 'K'],
                bottom: 0
              },
              tooltip: {
                trigger: 'axis',
                formatter: params => {
                  const str = params
                    .map((serie, index) => {
                      return (
                        serie.marker +
                        serie.seriesName +
                        '：' +
                        serie.data[0] +
                        (index === 0 ? 'm/s' : '')
                      );
                    })
                    .join('<br/>');
                  return str;
                }
              },
              toolbox: {
                bottom: 0,
                emphasis: {
                  iconStyle: {
                    textPosition: 'left'
                  }
                },
                feature: {
                  dataView: { readOnly:  true}
                }
              },
              angleAxis: {
                type: "value",
                startAngle: 90,
                boundaryGap: false,
                interval: 22.5,
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ['#000000'],
                    type: 'solid',
                    opacity: 1
                  }
                }
              },
              axisLabel: {
                show: true,
                fontSize: 12,
                formatter: function (param) {
                  return param + "°";
                },
              },
              polar: {
                radius: ['15%', '75%'],
              },
              radiusAxis: {
                z: 100
              },
              series: [
                {
                  type: 'line',
                  name: '风速',
                  symbol : 'none',
                  data: wsroses,
                  coordinateSystem: 'polar'
                },
                {
                  type: 'line',
                  name: 'A',
                  symbol : 'none',
                  data: aroses,
                  coordinateSystem: 'polar'
                },
                {
                  type: 'line',
                  name: 'K',
                  symbol : 'none',
                  data: kroses,
                  coordinateSystem: 'polar'
                },
              ]
            };
          },
          url: '/windfarm/meso/point/getWindRose',
          fileUrl: '/windfarm/meso/point/report/getWindRose',
          key: 'windEnergyRoseChart'
        },
        {
          name: '风切变',
          chartOptions: data => {
            const { windSpeed, exp, shear = [], height = [] } = data;
            const heightArr = shear.map((item, index) => {
              return [item, height[index]];
            });
            this.exp = exp;
            // windSpeed.sort((a, b) => {
            //   return a[0] - b[0];
            // });

            // const x = windSpeed.map(i => i[0]);
            // const y = windSpeed.map(i => i[1]);

            return {
              animation: false,
              tooltip: {
                trigger: 'axis',
                formatter: params => {
                  const [x, y] = params[0].value;
                  return `高度：${y}m <br /> 风速：${x}m/s`;
                }
              },
              grid: {
                right: '20',
                top: '40'
              },
              xAxis: {
                type: 'value',
                name: '风速(m/s)',
                boundaryGap: false,
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                },
                nameLocation: 'middle',
                nameGap: 30
              },
              yAxis: {
                min: 0,
                max: value => {
                  if (value.max <= 10) {
                    return 10;
                  }

                  let max = value.max * 1.2;
                  let val = max / 5;
                  const round = true;
                  const exponent = Math.floor(Math.log(val) / Math.LN10);
                  const exp10 = Math.pow(10, exponent);
                  const f = val / exp10; // 1 <= f < 10
                  let nf;
                  if (round) {
                    if (f < 1.5) {
                      nf = 1;
                    } else if (f < 2.5) {
                      nf = 2;
                    } else if (f < 4) {
                      nf = 3;
                    } else if (f < 7) {
                      nf = 5;
                    } else {
                      nf = 10;
                    }
                  } else {
                    if (f < 1) {
                      nf = 1;
                    } else if (f < 2) {
                      nf = 2;
                    } else if (f < 3) {
                      nf = 3;
                    } else if (f < 5) {
                      nf = 5;
                    } else {
                      nf = 10;
                    }
                  }
                  val = nf * exp10;
                  return val * 5;
                },
                type: 'value',
                name: '高度(m)',
                splitLine: {
                  lineStyle: {
                    type: 'dashed'
                  }
                }
              },
              series: [
                {
                  name: '高度',
                  type: 'line',
                  showSymbol: false,
                  smooth: true,
                  data: heightArr
                },
                {
                  name: '高度',
                  type: 'scatter',
                  data: windSpeed
                }
              ]
            };
          },
          url: '/windfarm/meso/point/getWindShear',
          fileUrl: '/windfarm/meso/point/report/getWindShear',
          key: 'windShearChart'
        },
        {
          name: '风向玫瑰图',
          chartOptions: data => {
            return {
              animation: false,
              tooltip: {
                trigger: 'item',
                formatter: '扇区：{b0} <br /> 占比：{c0} %'
              },
              toolbox: {
                bottom: 0,
                emphasis: {
                  iconStyle: {
                    textPosition: 'left'
                  }
                },
                feature: {
                  dataView: { readOnly:  true}
                }
              },
              textStyle: {},

              angleAxis: {
                type: 'category',
                data: data.sector,
                startAngle: -258.75,
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ['#000000'],
                    type: 'solid',
                    opacity: 1
                  }
                }
              },
              polar: {
                radius: ['15%', '75%'],
              },
              radiusAxis: {
                z: 100
              },
              series: [
                {
                  name: '占比',
                  type: 'bar',
                  data: data.frequency.map(i => toFixed(i, 2)),
                  coordinateSystem: 'polar'
                }
              ]
            };
          },
          url: '/windfarm/meso/point/getWindDirectionRose',
          fileUrl: '/windfarm/meso/point/report/getWindDirectionRose',
          key: 'windDirectionRoseChart'
        },
        {
          name: '风能玫瑰图',
          chartOptions: data => {
            return {
              animation: false,
              textStyle: {},
              tooltip: {
                trigger: 'item',
                formatter: '扇区：{b0} <br /> 占比：{c0} %'
              },
              toolbox: {
                bottom: 0,
                emphasis: {
                  iconStyle: {
                    textPosition: 'left'
                  }
                },
                feature: {
                  dataView: { readOnly:  true}
                }
              },
              angleAxis: {
                type: 'category',
                data: data.sector,
                startAngle: -258.75,
                splitLine: {
                  show: true,
                  lineStyle: {
                    color: ['#000000'],
                    type: 'solid',
                    opacity: 1
                  }
                }
              },
              polar: {
                radius: ['15%', '75%'],
              },
              radiusAxis: {
                z: 100
              },
              series: [
                {
                  name: '占比',
                  type: 'bar',
                  data: data.frequency.map(i => toFixed(i, 2)),
                  coordinateSystem: 'polar'
                }
              ]
            };
          },
          url: '/windfarm/meso/point/getWindEnergyRose',
          fileUrl: '/windfarm/meso/point/report/getWindEnergyRose',
          key: 'windEnergyRoseChart'
        }
      ]
    };
  },
  computed: {
    ...mapGetters(['isLogin']),
    ...mapGetters('WindFarm', ['dataSet']),
    classNames() {
      if (!this.isLogin) {
        return 'not-login';
      } else {
        return '';
      }
    }
    // ...this.transConfig(this.config)
  },
  watch: {
    itemConfig: {
      handler(val) {
        if (!val) return;
        const _this = this;
        this.isShowPoint = true;
        this.config = val;

        const {
          datasetCode = '',
          datasetHeight = '',
          itemId = '',
          lat = '',
          lon = ''
        } = val;

        if (!datasetCode) {
          const firstItem = this.dataSet[0] || {};
          this.config.datasetCode = firstItem?.datasetCode;
          this.datasetCode = this.config.datasetCode;
        } else {
          this.datasetCode = datasetCode;
        }

        const item = this.dataSet.find(item => item.datasetCode == _this.datasetCode);
        this.heightList = item?.datasetHeight;
        this.reportFlag = item?.reportFlag;
        this.buttonFlag = item?.buttonFlag;

        if (!datasetHeight) {
          this.config.datasetHeight = this.heightList[0] || '';
          this.datasetHeight =this.heightList[0] || '';
        }else{
          this.datasetHeight = datasetHeight;
        }

        this.querySummaryData({
          datasetCode: this.datasetCode,
          datasetHeight: this.datasetHeight,
          itemId,
          lat,
          lon
        });
        if(this.chartType) {
          this.queryChart(this.chartType);
        }
      },
      immediate: true
    },
    datasetCode(val) {
      const { itemId = '', lat = '', lon = '' } = this.config;
      this.querySummaryData({
        datasetCode: val,
        datasetHeight: this.datasetHeight,
        itemId,
        lat,
        lon
      });

      this.config.datasetCode = val;
      if(this.chartType) {
        this.queryChart(this.chartType);
      }
      if(this.itemConfig.itemId == 0){
        this.$bus.$emit('setNoIdPointItem', {
          datasetCode: this.config.datasetCode,
          datasetHeight: this.config.datasetHeight
        });
      }
    },
    config: {
      handler(val) {
        this.$emit('update:itemConfig', val);
      }
    },
    datasetHeight(val) {
      const { itemId = '', lat = '', lon = '' } = this.config;
      this.querySummaryData({
        datasetCode: this.datasetCode,
        datasetHeight: val,
        itemId,
        lat,
        lon
      });

      this.config.datasetHeight = val;
      if(this.chartType) {
        this.queryChart(this.chartType);
      }
      if(this.itemConfig.itemId == 0){
        this.$bus.$emit('setNoIdPointItem', {
          datasetCode: this.config.datasetCode,
          datasetHeight: this.config.datasetHeight
        });
      }
    }
  },
  methods: {
    handleCloseModalClick(modal) {
      if (modal === 'point') {
        this.isShowPoint = false;
        this.config = null;
        // if(this.itemConfig.itemId == 0){
        //   this.$store.commit('WindFarm/POP_MAP_POINT');
        // }
      }
      if (modal === 'chart') {
        this.chartType = null;
      }
    },
    handleDataDownChange(val) {
      const item = this.dataDownSet.find(i => i.datasetCode === val) || {};
      this.defaultStartDate = item.startDate;
      this.defaultEndDate = item.endDate;

      this.uploadForm.startDate = this.defaultStartDate;
      this.uploadForm.endDate = this.defaultEndDate;
    },
    handleDownData() {
      this.showDataDownLoadDialog = true;

      if (!this.dataDownSet.length) {
        this.$fetch('/windfarm/project/getDownDataSet').then(res => {
          const { data = {} } = res;
          const { dataSet = [] } = data;

          this.dataDownSet = dataSet.map(i => {
            return {
              ...i,
              label: i.datasetName,
              value: i.datasetCode
            };
          });
        });
      }
    },
    handleDatasetClick() {
      this.$refs.form.validate(valid => {
        if (valid) {
          if (
            moment(this.uploadForm.startDate).isBefore(this.defaultStartDate) ||
            moment(this.uploadForm.endDate).isAfter(this.defaultEndDate)
          ) {
            return this.$message.warning(
              `超出数据源的时间范围，范围应在${this.defaultStartDate}至${this.defaultEndDate}之间`
            );
          }

          if (
            moment(this.uploadForm.startDate).isAfter(this.uploadForm.endDate)
          ) {
            return this.$message.warning('结束时间不能超过开始时间');
          }

          const uploadForm = {
            ...this.uploadForm
          };

          uploadForm.startDate = uploadForm.startDate.replace(/-/g, '');
          uploadForm.endDate = uploadForm.endDate.replace(/-/g, '');

          const str =
            process.env.VUE_APP_API_HOST +
            '/windfarm/meso/point/getResourcesDataFile' +
            getQueryString({
              ...uploadForm,
              itemId: this.fromProjectList ? '0' : this.itemConfig.itemId,
              lat: this.itemConfig.lat,
              lon: this.itemConfig.lon,
              apiKey: this.fromProjectList ? '0' : getToken()
            });

          this.$message.warning('下载中，请稍等');
          window.open(str, '_parent');
        }
      });
    },
    dialogClose() {},
    toFixed,
    querySummaryData(params) {
      let myParams = params;

      if (this.fromProjectList) {
        this.$fetch('/windfarm/meso/point/getWindSummaryData', {
          showError: true,
          params: {
            ...myParams,
            itemId: '0',
            apiKey: this.isLogin ? null : '0'
          },
          noKey: this.fromProjectList
        }).then(res => {
          const { data = {} } = res;
          this.summaryData = data;
        });
      } else {
        this.$emit('updateItem',{
          datasetCode: params.datasetCode,
          datasetHeight: params.datasetHeight,
          itemId: params.itemId
        });
        this.$fetch('/windfarm/meso/point/getWindSummaryData', {
          showError: true,
          params: {
            ...myParams
          }
        }).then(res => {
          const { data = {} } = res;
          this.summaryData = data;
        });
      }
    },

    handleSelectChange(val) {
      const item = this.dataSet.find(item => item.datasetCode === val);
      this.heightList = item?.datasetHeight;
      this.reportFlag = item?.reportFlag;
      this.buttonFlag = item?.buttonFlag;
      this.config.datasetHeight = this.heightList[0] || '';
      this.datasetHeight = this.config.datasetHeight;
    },

    handleBtnClick(item) {
      if (this.chartType && this.chartType.name === item.name) {
        this.chartType = null;
      } else {
        this.chartType = item;
        this.queryChart(item);
      }
    },
    queryChart(item) {
      this.loading = true;

      const params = {
        datasetHeight: this.config.datasetHeight,
        datasetCode: this.config.datasetCode,
        itemId: this.config.itemId,
        lat: this.config.lat,
        lon: this.config.lon
      };

      this.$fetch(item.url, {
        showError: true,
        params: {
          ...params,
          itemId: this.fromProjectList ? '0' : params.itemId,
          apiKey: this.isLogin ? null : '0'
        },
        noKey: this.fromProjectList
      })
        .then(res => {
          this.loading = false;
          const { data } = res;
          this.chartOption = item.chartOptions(data) || {};
        })
        .catch(() => {
          this.loading = false;
        });
    },
    downReport(obj) {
      this.$postForm('/windfarm/meso/point/report/downReport', {
        showError: true,
        noJudge: true,
        responseType: 'blob',
        data: obj
      })
        .then(res => {
          const blob = new Blob([res.data]);

          var link = document.createElement('a');
          var fileURL = URL.createObjectURL(blob);
          link.target = '_blank';
          link.href = fileURL;
          let obj = this.dataSet.find(item => {
            return item.datasetCode === this.form.datasetCode;
          });
          link.download =
            this.rawData.name +
            '-' +
            obj.datasetName +
            '-' +
            this.form.datasetHeight +
            'm-点资源报告.doc'; //名称-数据源-高度-点资源报告
          link.click();
        })
        .catch(() => {});
    },
    handleDownReport() {
      const aswitch = loadingMask({ mask: true });
      requestChart({
        datasetCode: this.itemConfig.datasetCode,
        datasetHeight: this.itemConfig.datasetHeight,
        datasetHeights: this.heightList.join(','),
        lat: this.itemConfig.lat,
        lon: this.itemConfig.lon,
        itemId: this.fromProjectList ? '0' : this.itemConfig.itemId
      }).then(res => {
        const obj = { ...res };
        obj.itemId = this.fromProjectList ? '0' : this.itemConfig.itemId;

        this.$postForm('/windfarm/meso/point/report/downReport', {
          showError: true,
          noJudge: true,
          responseType: 'blob',
          data: obj
        })
          .then(res => {
            const blob = new Blob([res.data]);

            var link = document.createElement('a');
            var fileURL = URL.createObjectURL(blob);
            link.target = '_blank';
            link.href = fileURL;
            let obj = this.dataSet.find(item => {
              return item.datasetCode === this.datasetCode;
            });
            link.download =
              this.itemConfig.itemName +
              '-' +
              obj.datasetName +
              '-' +
              this.datasetHeight +
              'm-点资源报告.doc'; //名称-数据源-高度-点资源报告
            link.click();
            aswitch.close();
          })
          .catch(() => {
            aswitch.close();
          });
      });
    },
    del(){
      this.$emit('del',{
        itemId: this.itemConfig.itemId
      });

    },
    add(){
      const obj = {
        type: 'Point',
        coordinates: [this.config.lon, this.config.lat]
      };
      const str = JSON.stringify(obj);
      const params = {
        itemName: '未命名',
        itemType: '1',
        projectId: this.$route.query.projectId,
        geometryInfo: str
      };

      this.$emit('add',params);
    }
  }
};
</script>

<style lang="less" scoped>
.mycontent {
  padding: 5px 0px;
}

.top-area {
  padding: 0px 20px 10px 20px;

  .item {
    height: 36px;
    display: flex;
    align-items: center;
    padding: 3px 0px;
    .label {
      color: #000;
      width: 48px;
      text-align: right;
      margin-right: 10px;
    }
    .desc {
      color: #555;
    }
  }
}

.middle-area {
  padding: 10px 20px;
  background-color: #fff;
  .row {
    padding: 5px 0px;
    display: flex;
    align-items: center;
    .row-item {
      flex: 1;
      display: flex;
      align-items: center;
      &:nth-of-type(2n + 1) {
        flex: 1;
      }
      .key {
        span {
          width: 70px;
          display: inline-block;
        }
      }
      .value {
        margin-left: 6px;
        flex: 1;
      }
      &:nth-of-type(2n) {
        margin-left: 10px;
      }
    }
  }
}

.btn-area {
  padding: 10px 0 0 20px;
  .btn-item {
    user-select: none;
    display: inline-block;
    padding: 5px;
    line-height: 20px;
    width: 92px;
    border: 2px solid #a8cae9;
    text-align: center;
    border-radius: 4px;
    background-color: #d9e6f3;
    cursor: pointer;
    margin-bottom: 5px;
    &:nth-child(4n + 1) {
      margin-right: 5px;
    }
    &:nth-child(4n + 2) {
      margin-right: 5px;
    }
    &:nth-child(4n + 3) {
      margin-right: 5px;
    }
    &.is-active {
      background-color: #0159ac;
      color: #fff;
    }
    &.is-disabled {
      color: #999;
      cursor: default;
    }
  }
}

.chart-modal {
  top: 0;
  right: -425px;
  left: unset;

  .plus-content {
    position: absolute;
    color: #fff;
    font-size: 12px;
    right: 30px;
    top: 66px;
    z-index: 2000;
    color: #000000;
  }
}
.chart-content {
  padding: 10px;
  height: 100%;
  .chart-c {
    background-color: #fff;
    height: 100%;
    padding: 5px;
    border-radius: 7px;
  }
}

.down-area {
  flex-direction: row-reverse;
  padding: 0px 20px;
  display: flex;
}

.data-content {
  padding: 10px;
}

.vtn-wrp {
  text-align: right;
  margin-top: 10px;
}
</style>
